<template>
  <div class="sys-page">
    <div class="toolbar">
      <h3>用户管理</h3>
      <el-button v-perm="'system:user:save'" type="primary" size="small" @click="openEdit(null)">新增用户</el-button>
    </div>

    <el-table :data="users" v-loading="loading" border stripe size="small">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="username" label="用户名" />
      <el-table-column prop="nickname" label="昵称" />
      <el-table-column label="状态" width="100">
        <template slot-scope="s">{{ s.row.status === 1 ? "启用" : "禁用" }}</template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180" />
      <el-table-column label="操作" width="280">
        <template slot-scope="s">
          <el-button v-perm="'system:user:save'" size="mini" @click="openEdit(s.row)">编辑</el-button>
          <el-button v-perm="'system:user:assign'" size="mini" type="primary" plain @click="openAssign(s.row)">分配角色</el-button>
          <el-button v-perm="'system:user:delete'" size="mini" type="danger" plain @click="removeUser(s.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="editing.id ? '编辑用户' : '新增用户'" :visible.sync="editVisible" width="480px">
      <el-form :model="editing" label-width="80px" size="small">
        <el-form-item label="用户名">
          <el-input v-model="editing.username" :disabled="!!editing.id" />
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="editing.nickname" />
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="editing.password" type="password" :placeholder="editing.id ? '留空则不修改' : '新建必填'" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="editing.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="editVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveUser">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="'分配角色 - ' + (assignTarget.username || '')" :visible.sync="assignVisible" width="420px">
      <el-checkbox-group v-model="assignRoleIds">
        <div v-for="r in allRoles" :key="r.id" style="margin-bottom: 6px;">
          <el-checkbox :label="r.id">{{ r.roleName }} ({{ r.roleKey }})</el-checkbox>
        </div>
      </el-checkbox-group>
      <div slot="footer">
        <el-button size="small" @click="assignVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveAssign">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { systemModules } from "@r";

export default {
  data() {
    return {
      loading: false,
      users: [],
      allRoles: [],
      editVisible: false,
      editing: this.blankUser(),
      assignVisible: false,
      assignTarget: {},
      assignRoleIds: [],
    };
  },
  created() {
    this.loadUsers();
    this.loadRoles();
  },
  methods: {
    blankUser() {
      return { id: null, username: "", nickname: "", password: "", status: 1 };
    },
    loadUsers() {
      this.loading = true;
      systemModules.listUsers()
        .then(res => { this.users = res.data || []; })
        .catch(e => this.$message.error(e.message || "加载用户失败"))
        .finally(() => { this.loading = false; });
    },
    loadRoles() {
      systemModules.listRoles()
        .then(res => { this.allRoles = res.data || []; })
        .catch(() => {});
    },
    openEdit(row) {
      this.editing = row ? { ...row, password: "" } : this.blankUser();
      this.editVisible = true;
    },
    saveUser() {
      const payload = { ...this.editing };
      if (payload.id && !payload.password) delete payload.password;
      systemModules.saveUser(payload)
        .then(() => {
          this.$message.success("保存成功");
          this.editVisible = false;
          this.loadUsers();
        })
        .catch(e => this.$message.error(e.message || "保存失败"));
    },
    removeUser(row) {
      this.$confirm(`确认删除用户 ${row.username} ?`, "提示", { type: "warning" })
        .then(() => systemModules.deleteUser(row.id))
        .then(() => {
          this.$message.success("已删除");
          this.loadUsers();
        })
        .catch(e => e !== "cancel" && this.$message.error((e && e.message) || "删除失败"));
    },
    openAssign(row) {
      this.assignTarget = row;
      this.assignRoleIds = [];
      this.assignVisible = true;
      systemModules.getUserRoles(row.id)
        .then(res => { this.assignRoleIds = res.data || []; })
        .catch(() => {});
    },
    saveAssign() {
      systemModules.assignUserRoles(this.assignTarget.id, this.assignRoleIds)
        .then(() => {
          this.$message.success("角色已更新");
          this.assignVisible = false;
        })
        .catch(e => this.$message.error(e.message || "保存失败"));
    },
  },
};
</script>

<style scoped>
.sys-page { padding: 16px; background: #fff; min-height: 100%; }
.toolbar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.toolbar h3 { margin: 0; }
</style>
